// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

// Tek-uçuş: aynı GET'i aynı anda (veya kısa pencerede) isteyen bileşenler tek HTTP isteğini
// paylaşır. İlk açılışta iki farklı bileşenin aynı ucu ikişer kez çektiği ölçüldü
// (onboarding/state, company-profile — 2026-08-25). Yanıt ttlMs boyunca taze sayılır;
// hata cache'lenmez (sonraki çağrı yeniden dener).

interface Ucus {
  readonly sonuc: Promise<unknown>;
  readonly zaman: number;
}

const ucuslar = new Map<string, Ucus>();

export function tekUcus<T>(anahtar: string, getir: () => Promise<T>, ttlMs = 5000): Promise<T> {
  const simdi = Date.now();
  const mevcut = ucuslar.get(anahtar);
  if (mevcut && simdi - mevcut.zaman < ttlMs) {
    return mevcut.sonuc as Promise<T>;
  }
  const sonuc = getir().catch((err: unknown) => {
    ucuslar.delete(anahtar); // hata taze sayılmaz — sonraki çağrı ağa çıkar
    throw err;
  });
  ucuslar.set(anahtar, { sonuc, zaman: simdi });
  return sonuc;
}

// Yazma işlemi sonrası (örn. profil güncellendi) taze kopya bayatladı — düşür.
export function tekUcusDusur(anahtar: string): void {
  ucuslar.delete(anahtar);
}
